import { Route } from 'kts-platform-frame/routes';

const parentName: string = '/workbench/platform/document'; // 路由的跟节点；

Route.addNode(
    parentName,
    { nodeName: '/workbench/platform/document/documentList', path: '*/documentList', component: require('./DocumentList').default},
    { nodeName: '/workbench/platform/document/editDocument', path: '*/editDocument/:type/:uuid', component: require('./EditDocument').default },
    { nodeName: '/workbench/platform/document/documentDetail', path: '*/documentDetail/:documentUUID', component: require('./DocumentDetail').default },
    { nodeName: '/workbench/platform/document/invoiceDetail', path: '*/invoiceDetail/:id', component: require('./InvoiceDetail').default },
);

export default {
    getChildReact: (index?: string) => {
        return Route.getChildReact(parentName, index);
    },
};

export {
    Switch
} from 'react-router-dom';


// WEBPACK FOOTER //
// ./src/display/platform/Document/Modules.Route.tsx